// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookableGiftcardResponse

import { GiftcardValidityMode } from './enums.gen';
import { DateTimefromYmd, DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BookableGiftcardApiResponse = {
	id: string;
	realPrice: number;
	onlinePrice: number;
	label: string;
	description: string;
	cardColor: string;
	textColor: string | null;
	backgroundOverlayDisplay: boolean;
	icon: string | null;
	logo: string | null;
	backgroundImage: string | null;
	publishStart: string | null;
	publishEnd: string | null;
	validityMode: GiftcardValidityMode;
	validityPeriod: number | null;
	validityDate: string | null;
};

export type BookableGiftcard = {
	id: string;
	realPrice: number;
	onlinePrice: number;
	label: string;
	description: string;
	cardColor: string;
	textColor: string | null;
	backgroundOverlayDisplay: boolean;
	icon: string | null;
	logo: string | null;
	backgroundImage: string | null;
	publishStart: DateTime | null;
	publishEnd: DateTime | null;
	validityMode: GiftcardValidityMode;
	validityPeriod: number | null;
	validityDate: DateTime | null;
};

export function hydrateBookableGiftcard(data: BookableGiftcardApiResponse): BookableGiftcard {
	return {
		...data,
		publishStart: DateTimefromISO(data.publishStart),
		publishEnd: DateTimefromISO(data.publishEnd),
		validityDate: DateTimefromYmd(data.validityDate),
	};
}